import React, { memo } from 'react';

interface TemplateSkeletonProps {
  count?: number;
}

const TemplateSkeleton: React.FC<TemplateSkeletonProps> = memo(
  ({ count = 3 }) => (
    <div className="template-container">
      {Array?.from({ length: count })?.map((_, index) => (
        <div
          className="template skeleton-template"
          // eslint-disable-next-line react/no-array-index-key
          key={`skeleton-${index}`}
        >
          <div className="template-header">
            <div className="star-title">
              <div className="skeleton-title" />
              <div className="skeleton-icon" />
            </div>
            <div className="skeleton-cost">
              <div className="skeleton-globe" />
              <div className="skeleton-cost-text" />
            </div>
          </div>
          <div className="template-body">
            <div className="skeleton-description" />
            <div className="skeleton-description" />
          </div>
          <div className="properties-capsule">
            <div className="skeleton-tags">
              <div className="skeleton-tag" />
              <div className="skeleton-tag" />
              <div className="skeleton-tag" />
            </div>
            <div className="skeleton-arrow" />
          </div>
        </div>
      ))}
    </div>
  ),
);

export default TemplateSkeleton;
